(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-pagination"] = factory();
	else
		root["vue-pagination"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VuePagination.vue?vue&type=template&id=c983849e&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalRows > _vm.pageSize),expression:"totalRows > pageSize"}],staticClass:"sf-pagination"},[_c('h2',{staticClass:"sr-only",attrs:{"id":"sf-pagination-a11y","aria-live":"polite"}},[_vm._v(_vm._s(_vm.$t('pageOfA11Y', { value: _vm.value, numberOfPages: _vm.numberOfPages })))]),_c('div',{staticClass:"sf-pagination__wrapper",class:{ 'sf-pagination__wrapper-mobile-compact': _vm.isMobile && _vm.mobileView == _vm.MOBILE_VIEWS.DOTS }},[(_vm.firstLastPage == true)?_c('button',{staticClass:"sf-pagination__btn first",attrs:{"type":"button","disabled":_vm.buttonPrevDisabled || _vm.disabled,"aria-label":_vm.$t('firstPage')},on:{"click":_vm.goToFirst}},[_c('svg',{attrs:{"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.227058 0.216151C0.529802 -0.0720503 1.02065 -0.0720503 1.32339 0.216151L7.68212 6.26943C8.10596 6.67291 8.10596 7.32709 7.68212 7.73057L1.32339 13.7838C1.02065 14.0721 0.529802 14.0721 0.227058 13.7838C-0.0756859 13.4956 -0.0756859 13.0284 0.227058 12.7402L6.25689 7L0.227058 1.25982C-0.0756858 0.971619 -0.0756855 0.504352 0.227058 0.216151Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.22706 0.216151C5.5298 -0.0720503 6.02065 -0.0720503 6.32339 0.216151L12.6821 6.26943C13.106 6.67291 13.106 7.32709 12.6821 7.73057L6.32339 13.7838C6.02065 14.0721 5.5298 14.0721 5.22706 13.7838C4.92431 13.4956 4.92431 13.0284 5.22706 12.7402L11.2569 7L5.22706 1.25982C4.92431 0.971619 4.92431 0.504352 5.22706 0.216151Z","fill":"white"}})])]):_vm._e(),_c('button',{staticClass:"sf-pagination__btn prev",class:{ 'sf-pagination__btn--dots': _vm.isMobile && _vm.mobileView == _vm.MOBILE_VIEWS.DOTS },attrs:{"type":"button","disabled":_vm.buttonPrevDisabled || _vm.disabled,"aria-label":_vm.$t('previousPage')},on:{"click":_vm.goToPrev}},[_c('svg',{attrs:{"width":"24","height":"24","viewbox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14 6L8 12L14 18","stroke":"#ABABAB","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile),expression:"isMobile"}],staticClass:"sf-pages",attrs:{"aria-labelledby":"sf-pagination-a11y"}},[(_vm.mobileView == _vm.MOBILE_VIEWS.PAGER)?[_c('span',{staticClass:"sr-only",attrs:{"id":"sf-pagination-a11y-current"}},[_vm._v(_vm._s(_vm.$t('currentPage')))]),_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(`${_vm.value} / ${_vm.numberOfPages}`))]),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('pageA11Y', { value: _vm.value })))])]:_vm._e(),(_vm.mobileView == _vm.MOBILE_VIEWS.DOTS)?[_c('span',{staticClass:"sr-only",attrs:{"id":"sf-pagination-a11y-current"}},[_vm._v(_vm._s(_vm.$t('currentPage')))]),_vm._l((_vm.numberOfPages),function(page){return _c('span',{key:page,staticClass:"sf-pagination__dot",class:{ 'sf-pagination__dot--active': _vm.value == page },attrs:{"aria-labelledby":_vm.value == page ? 'sf-pagination-a11y-current' : false}})}),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('pageA11Y', { value: _vm.value })))])]:_vm._e()],2),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"sf-pagination__items",attrs:{"aria-labelledby":"sf-pagination-a11y"}},[_c('li',{staticClass:"sf-pagination__item number",class:{ active: _vm.value == 1 },attrs:{"aria-labelledby":_vm.value == 1 ? 'sf-pagination-a11y-current' : false,"aria-current":"page"}},[_c('button',{attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.goToPage(1)}}},[_vm._v("1")]),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('pageA11Y', { value: 1 })))])]),(_vm.showFirstDots)?_c('li',{staticClass:"sf-pagination__item more-items",attrs:{"aria-hidden":"true"}},[_vm._v("...")]):_vm._e(),_vm._l((_vm.pages),function(page){return _c('li',{key:page,staticClass:"sf-pagination__item number",class:{ active: _vm.value == page },attrs:{"aria-labelledby":_vm.value == page ? 'sf-pagination-a11y-current' : false}},[_c('button',{attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.goToPage(page)}}},[_vm._v(_vm._s(page))]),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('pageA11Y', { value: page })))])])}),(_vm.showLastDots)?_c('li',{staticClass:"sf-pagination__item more-items",attrs:{"aria-hidden":"true"}},[_vm._v("...")]):_vm._e(),(_vm.numberOfPages > 1)?_c('li',{staticClass:"sf-pagination__item number",class:{ active: _vm.value == _vm.numberOfPages },attrs:{"aria-label":_vm.value == _vm.numberOfPages ? 'sf-pagination-a11y-current' : false}},[_c('button',{attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.goToPage(_vm.numberOfPages)}}},[_vm._v(_vm._s(_vm.numberOfPages))]),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('pageA11Y', { value: _vm.numberOfPages })))])]):_vm._e()],2),_c('button',{staticClass:"sf-pagination__btn next",class:{ 'sf-pagination__btn--dots': _vm.isMobile && _vm.mobileView == _vm.MOBILE_VIEWS.DOTS },attrs:{"type":"button","disabled":_vm.buttonNextDisabled || _vm.disabled,"aria-label":_vm.$t('nextPage')},on:{"click":_vm.goToNext}},[_c('svg',{attrs:{"width":"24","height":"24","viewbox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 6L16 12L10 18","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])]),(_vm.firstLastPage == true)?_c('button',{staticClass:"sf-pagination__btn last",attrs:{"type":"button","disabled":_vm.buttonNextDisabled || _vm.disabled,"aria-label":_vm.$t('lastPage')},on:{"click":_vm.goToLast}},[_c('svg',{attrs:{"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.227058 0.216151C0.529802 -0.0720503 1.02065 -0.0720503 1.32339 0.216151L7.68212 6.26943C8.10596 6.67291 8.10596 7.32709 7.68212 7.73057L1.32339 13.7838C1.02065 14.0721 0.529802 14.0721 0.227058 13.7838C-0.0756859 13.4956 -0.0756859 13.0284 0.227058 12.7402L6.25689 7L0.227058 1.25982C-0.0756858 0.971619 -0.0756855 0.504352 0.227058 0.216151Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.22706 0.216151C5.5298 -0.0720503 6.02065 -0.0720503 6.32339 0.216151L12.6821 6.26943C13.106 6.67291 13.106 7.32709 12.6821 7.73057L6.32339 13.7838C6.02065 14.0721 5.5298 14.0721 5.22706 13.7838C4.92431 13.4956 4.92431 13.0284 5.22706 12.7402L11.2569 7L5.22706 1.25982C4.92431 0.971619 4.92431 0.504352 5.22706 0.216151Z","fill":"white"}})])]):_vm._e()])])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/VuePagination.lang.json
const VuePagination_lang_namespaceObject = JSON.parse('{"hu":{"pageOfA11Y":"Lapozó - {value}. oldal a(z) {numberOfPages} oldalból","currentPage":"Aktuális oldal","pageA11Y":"{value}. oldal","previousPage":"Előző oldal","firstPage":"Első oldal","nextPage":"Következő oldal","lastPage":"Utolsó oldal"},"en":{"pageOfA11Y":"Pagination - page {value} of {numberOfPages} pages","currentPage":"Current page","pageA11Y":"page {value}","previousPage":"Previous page","firstPage":"First page","nextPage":"Next page","lastPage":"Last Page"}}');
;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VuePagination.vue?vue&type=script&lang=js&



const VISIBLE_COUNT = 10;
const MAX_PAGES = 10;
const MOBILE_VIEWS = {
	PAGER: 'pager',
	DOTS: 'dots'
};
/* harmony default export */ const VuePaginationvue_type_script_lang_js_ = ({
	name: 'VuePagination',
	i18n: { messages: VuePagination_lang_namespaceObject },
	props: {
		/**
		 * If used with v-model this prop is automatically injected
		 */
		value: {
			type: Number,
			default: 1
		},
		/**
		 * The expected number of items listed outside the pagination component, when selecting a pagination number
		 */
		pageSize: {
			type: Number,
			default: 10
		},
		/**
		 * The expected total number of items handled by the component
		 */
		totalRows: {
			type: Number,
			required: true
		},
		/**
		 * Shows/hides the jump-to-end navigation
		 */
		firstLastPage: {
			type: Boolean,
			required: false,
			default: false
		},
		/**
		 * If disabled, removes the maximum limit for the pagination items
		 */
		hasMaxPage: {
			type: Boolean,
			default: true
		},
		/**
		 * Disables the pagination component
		 */
		disabled: {
			type: Boolean,
			default: false
		},
		mobileView: {
			default: MOBILE_VIEWS.PAGER,
			validator(val) {
				return Object.values(MOBILE_VIEWS).includes(val);
			}
		}
	},
	mixins: [a],
	computed: {
		MOBILE_VIEWS: () => MOBILE_VIEWS,
		showFirstDots() {
			return this.numberOfPages > VISIBLE_COUNT && this.value >= 5;
		},
		showLastDots() {
			return this.numberOfPages > VISIBLE_COUNT && this.pages[this.pages.length - 1] < this.numberOfPages - 1;
		},
		numberOfPages() {
			const pages = Math.ceil(this.totalRows / this.pageSize);
			return this.hasMaxPage ? Math.min(pages, MAX_PAGES) : pages;
		},
		buttonPrevDisabled() {
			return this.value == 1;
		},
		buttonNextDisabled() {
			return this.value == this.numberOfPages;
		},
		/***********************************
		 * Pages from 2 to numberOfPages -1 but only 7 from the beginning or 7 from the end
		 ***********************************/
		pages() {
			let range = [];
			if (this.numberOfPages > 1) {
				let start;
				let end;
				if (this.numberOfPages <= VISIBLE_COUNT || this.value < 5) {
					start = 2;
				} else {
					start = this.numberOfPages - this.value < VISIBLE_COUNT - 4 ? this.numberOfPages - (VISIBLE_COUNT - 3) : this.value - 1;
				}
				if (this.numberOfPages <= VISIBLE_COUNT) {
					end = this.numberOfPages - 1;
				} else {
					end = Math.min(this.numberOfPages - 1, start + VISIBLE_COUNT - 4);
				}
				for (let i = start; i <= end; i++) {
					range.push(i);
				}
			}
			return range;
		}
	},
	methods: {
		goToNext() {
			this.goToPage(this.value + 1);
		},
		goToLast() {
			this.goToPage(this.numberOfPages);
		},
		goToPrev() {
			this.goToPage(this.value - 1);
		},
		goToFirst() {
			this.goToPage(1);
		},
		goToPage(page) {
			this.$emit('input', page);
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VuePagination.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VuePaginationvue_type_script_lang_js_ = (VuePaginationvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-62.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-62.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-62.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-62.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VuePagination.vue?vue&type=style&index=0&id=c983849e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VuePagination.vue?vue&type=style&index=0&id=c983849e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VuePagination.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VuePaginationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "c983849e",
  null
  
)

/* harmony default export */ const VuePagination = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VuePagination);


__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-pagination.umd.js.map